import React, { useState, useEffect } from 'react';

// Main component using iframe approach to completely isolate Three.js
export default function StreamBackground() {
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const [iframeError, setIframeError] = useState(false);
  const [mounted, setMounted] = useState(false);

  // Only render on client-side to avoid hydration issues
  useEffect(() => {
    setMounted(true);
  }, []);

  // Fallback gradient background
  const fallbackBackground = (
    <div className="fixed inset-0 -z-10 opacity-50 bg-gradient-to-br from-dark-900 to-purple-900"></div>
  );

  // If not mounted yet (during SSR), return the fallback
  if (!mounted) {
    return fallbackBackground;
  }

  // If iframe had an error, return the fallback
  if (iframeError) {
    return fallbackBackground;
  }

  return (
    <div className="fixed inset-0 -z-10 opacity-50">
      {/* Show fallback until iframe is loaded */}
      {!iframeLoaded && fallbackBackground}
      
      <iframe 
        src="/three-background.html" 
        className="w-full h-full border-0"
        style={{ 
          opacity: iframeLoaded ? 1 : 0,
          transition: 'opacity 0.5s ease-in-out'
        }}
        onLoad={() => setIframeLoaded(true)}
        onError={() => setIframeError(true)}
        title="3D Background"
        aria-hidden="true"
      />
    </div>
  );
}